import { Icon } from "@/lib/Icon";

/** Sign-in header: the brand mark and "Patient Portal". The storefront
 *  build swaps this module (vite.config.ts) for the store's own header. */
export function LoginTopBar() {
  return (
    <header className="flex items-center justify-between border-b border-black/10 bg-[#ECECEC]">
      <div className="w-[5rem] h-[5rem] flex items-center justify-center bg-slate">
        <div className="w-full max-w-[3rem] text-black">
          <Icon name="Mark Line" viewBox="0 0 32 30" />
        </div>
      </div>
      <div className="font-mono text-12 uppercase text-black px-15">
        Patient Portal
      </div>
    </header>
  );
}
